import React from 'react';

import axios, { AxiosResponse } from 'axios';

import {
  LSPaymentHardwareSetupStatus,
  useLightspeedPaymentsSetupStatus,
} from 'root/apps/hooks/useLightspeedPaymentsSetupStatus';

export const useCheckRemoteDepositPaymentLink = (saleID: number, refreshIterator = 0) => {
  const [
    currentSaleRemoteDepositPaymentLinkRequest,
    setCurrentSaleRemoteDepositPaymentLinkRequest,
  ] = React.useState<AxiosResponse<any> | null>(null);
  const [isCheckingForExistingRemoteDepositRequest, setIsCheckingForExistingRemoteDepositRequest] =
    React.useState(false);

  const { status: lightspeedPaymentsSetupStatus } = useLightspeedPaymentsSetupStatus();

  React.useEffect(() => {
    const checkCurrentSaleHasRemoteDepositPaymentLinkRequest = async (saleID: number) => {
      setIsCheckingForExistingRemoteDepositRequest(true);
      try {
        const remoteDepositPaymentLinkRequest = await axios.get(
          `/admin/sale/${saleID}/remote-deposit`
        );

        setCurrentSaleRemoteDepositPaymentLinkRequest(remoteDepositPaymentLinkRequest);
      } catch (error) {
        setCurrentSaleRemoteDepositPaymentLinkRequest(null);
      } finally {
        setIsCheckingForExistingRemoteDepositRequest(false);
      }
    };

    if (
      lightspeedPaymentsSetupStatus ===
        LSPaymentHardwareSetupStatus.INCOMPLETE_GATEWAY_ACTIVE_TERMINAL_UNPAIRED ||
      lightspeedPaymentsSetupStatus === LSPaymentHardwareSetupStatus.TRANSACTIONAL
    ) {
      checkCurrentSaleHasRemoteDepositPaymentLinkRequest(saleID);
    }
  }, [lightspeedPaymentsSetupStatus, saleID, refreshIterator]);

  return { currentSaleRemoteDepositPaymentLinkRequest, isCheckingForExistingRemoteDepositRequest };
};
